import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from './constants/routes';
import { COLOURS } from './constants/colours';
import { Analytics } from "@vercel/analytics/react";
import HomePage from "./pages/HomePage/HomePage";
import GalleryPage from "./pages/GalleryPage/GalleryPage"
import AnimationPage from "./pages/AnimationPage/AnimationPage"
import AboutPage from "./pages/AboutPage/AboutPage"
import { useEffect, useState } from 'react';

const getRandomColours = () => {
    const colourList = [
        COLOURS.redStyle,
        COLOURS.tealStyle,
        COLOURS.purpleStyle,
        COLOURS.blueStyle,
        COLOURS.greenStyle,
        COLOURS.orangeStyle
    ];

    const randomIndex = Math.floor(Math.random() * colourList.length);

    return colourList[randomIndex];
}

export const dynamicClassName = (currentColours) => {
    return currentColours ? currentColours.className : COLOURS.defaultStyle.className;
}

function App() {
    const [colourClassName, setColourClassName] = useState('');
     let currentColours = "";
    
    useEffect(() => {
      currentColours = getRandomColours();
      setColourClassName(dynamicClassName(currentColours));

        const handleContextMenu = (event) => {
          if (event.target.tagName === 'IMG' || 'VIDEO') {
            event.preventDefault();
          }
        };
    
        document.addEventListener('contextmenu', handleContextMenu);
    
        return () => {
          document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    return (
      <>
        <Routes>
        <Route path={ROUTES.home} element={<HomePage colourClassName={colourClassName}/>} />
        <Route path={ROUTES.gallery} element={<GalleryPage colourClassName={colourClassName}/>} />
        <Route path={ROUTES.animation} element={<AnimationPage colourClassName={colourClassName}/>} />
        <Route path={ROUTES.about} element={<AboutPage colourClassName={colourClassName}/>} />
        </Routes>
        <Analytics />
      </>
    );
}

export default App;